import React from 'react';
import { motion } from 'framer-motion';
import { CommunityPartners } from '@/pages/public/Team';

const partners = [
  "JP Morgan Chase",
  "Encompass Health",
  "Accra Psychiatric Hospital",
  "ReMax",
  "Shama District Assembly",
  "Ghana Health Services",
  "Volta River Authority",
  "Starbucks",
  "Costco",
  "Nothing Bundt Cakes"
];

export default function Partners() {
  return (
    <section id="partners" className="py-16 sm:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">Together We Grow</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground">
            Our Community <span className="text-primary italic">Partners</span>
          </h2>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            We are grateful for the partnerships that make our work possible.
          </p>
        </motion.div>

        {/* <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {partners.map((partner, i) => (
            <motion.div
              key={partner}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="bg-card border border-border rounded-xl p-5 flex items-center justify-center text-center hover:shadow-md transition-shadow"
            >
              <span className="text-sm font-medium text-muted-foreground">{partner}</span>
            </motion.div>
          ))}
        </div> */}

        <CommunityPartners justIcons={true} />

        {/* <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mt-10 text-muted-foreground text-sm"
        >
          Interested in becoming a partner or sponsor?{' '}
          <a href="mailto:info@roseofjericho-cd.org" className="text-primary hover:underline font-medium">
            Contact us
          </a>
        </motion.p> */}
      </div>
    </section>
  );
}